import { Tool } from '../../types';

export const marketingTools: Tool[] = [
  {
    id: 'semrush',
    name: 'Semrush',
    category: 'Marketing',
    description: 'Comprehensive digital marketing and SEO toolkit trusted by over 10 million marketers. Research keywords, audit websites, track rankings, analyze competitors, and manage social media. Essential for data-driven marketing strategies.',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'analytics'],
    bestFor: ['small-business', 'agency'],
    compatibleWith: ['agency', 'service-business', 'content-creator'],
    goals: ['improve-marketing', 'increase-sales', 'build-brand'],
    industries: ['marketing', 'technology', 'consulting'],
    website: 'https://www.semrush.com',
    imageUrl: 'https://logo.clearbit.com/semrush.com',
    idealStages: ['growing', 'scaling'],
    workEnvironments: ['remote', 'hybrid'],
    minTeamSize: 'solo'
  },
  {
    id: 'ahrefs',
    name: 'Ahrefs',
    category: 'Marketing',
    description: 'Premium SEO toolset known for the largest backlink index in the industry. Discover ranking keywords, analyze competitors, find content gaps, and track your search visibility. Trusted by SEO professionals worldwide for accurate data.',
    pricing: ['medium', 'high'],
    features: ['analytics', 'integrations'],
    bestFor: ['small-business', 'agency'],
    compatibleWith: ['agency', 'content-creator'],
    goals: ['improve-marketing', 'build-brand'],
    industries: ['marketing', 'technology'],
    website: 'https://ahrefs.com',
    imageUrl: 'https://logo.clearbit.com/ahrefs.com',
    idealStages: ['growing', 'scaling'],
    workEnvironments: ['remote', 'hybrid'],
    minTeamSize: 'solo'
  },
  {
    id: 'convertkit',
    name: 'ConvertKit',
    category: 'Marketing',
    description: 'Email marketing platform built specifically for creators, bloggers, and online business owners. Visual automation builder, landing pages, commerce features, and subscriber tagging. Grow and monetize your audience effectively.',
    pricing: ['medium'],
    features: ['automation', 'integrations', 'ease-of-use'],
    bestFor: ['solopreneur', 'freelancer'],
    compatibleWith: ['content-creator', 'online-business'],
    goals: ['improve-marketing', 'increase-sales', 'build-brand'],
    industries: ['marketing', 'creative'],
    website: 'https://partners.kit.com/70971bvefugb',
    imageUrl: 'https://logo.clearbit.com/convertkit.com',
    idealStages: ['launching', 'growing'],
    workEnvironments: ['remote'],
    minTeamSize: 'solo'
  },
  {
    id: 'go-high-level',
    name: 'Go High Level',
    category: 'Marketing',
    description: 'All-in-one marketing and business platform for agencies',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'support', 'scalability'],
    bestFor: ['startup', 'agency', 'small-business'],
    compatibleWith: ['agency', 'service-business', 'consulting-firm'],
    goals: ['improve-marketing', 'automate-tasks', 'increase-sales', 'enhance-customer-service'],
    industries: ['marketing', 'consulting', 'technology'],
    website: 'https://www.gohighlevel.com/?fp_ref=76f9e',
    imageUrl: 'https://logo.clearbit.com/gohighlevel.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'click-funnels',
    name: 'ClickFunnels',
    category: 'Marketing',
    description: 'Sales funnel builder and marketing automation platform',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'ease-of-use'],
    bestFor: ['small-business', 'content-creator'],
    compatibleWith: ['e-commerce', 'service-business', 'content-creator'],
    goals: ['increase-sales', 'improve-marketing', 'automate-tasks'],
    industries: ['marketing', 'retail', 'consulting'],
    website: 'https://www.clickfunnels.com/signup-flow-new-plans?aff=dbca6bac1da31db8ec0df1874fe9ccef05a144a3090ebb752dafe1f49f69efb0',
    imageUrl: 'https://logo.clearbit.com/clickfunnels.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'mailchimp',
    name: 'Mailchimp',
    category: 'Marketing',
    description: 'Email marketing and automation platform',
    pricing: ['free', 'medium', 'high'],
    features: ['automation', 'ease-of-use', 'integrations', 'mobile'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['e-commerce', 'content-creator', 'service-business'],
    goals: ['improve-marketing', 'increase-sales', 'build-brand'],
    industries: ['retail', 'marketing', 'creative'],
    website: 'https://mailchimp.com',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'active-campaign',
    name: 'ActiveCampaign',
    category: 'Marketing',
    description: 'Customer experience automation platform',
    pricing: ['medium', 'high'],
    features: ['automation', 'integrations', 'mobile', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['e-commerce', 'service-business', 'saas'],
    goals: ['improve-marketing', 'increase-sales', 'enhance-customer-service'],
    industries: ['retail', 'technology', 'marketing'],
    website: 'https://www.activecampaign.com/?_r=W2ZN66KG',
    imageUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'tradepass',
    name: 'TradePass',
    category: 'Marketing',
    description: 'Digital business card and lead generation tool for contractors and tradesmen. Get 3x more callbacks with shareable QR codes, instant quote request notifications, and one-tap contact saving.',
    pricing: ['low'],
    features: ['ease-of-use', 'mobile'],
    bestFor: ['trades', 'freelancer', 'solopreneur'],
    compatibleWith: ['plumbing', 'electrical', 'carpentry', 'hvac', 'landscaping', 'cleaning', 'property-management'],
    goals: ['increase-sales', 'expand-customer-base', 'build-brand'],
    industries: ['trades', 'home-services'],
    website: 'https://tradepassapp.com',
    imageUrl: 'https://logo.clearbit.com/tradepassapp.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    workEnvironments: ['in-person', 'hybrid'],
    customerModels: ['b2c', 'both'],
    locationTypes: ['physical', 'both'],
    minTeamSize: 'solo'
  }
];